import { useEffect } from "react";
import { useToasts } from "react-toast-notifications";

import { Notification as INotification } from "../../interfaces";

interface NotificationProps {
  notification: INotification | null;
}

const AUTO_DISMISS_TIMEOUT = 6000;

const Notification = (props: NotificationProps) => {
  const { notification } = props;
  const { addToast, removeAllToasts } = useToasts();

  useEffect(() => {
    removeAllToasts();

    if (notification) {
      addToast(notification.message, {
        appearance: notification.appearance,
        autoDismiss: true,
        autoDismissTimeout: AUTO_DISMISS_TIMEOUT,
      });
    }
  }, [addToast, removeAllToasts, notification]);

  return null;
};

export default Notification;
